module.exports = __webpack_public_path__ + "static/005-7e3b3195225bc31851cbfdcb43e7a5f1.png";